import { render } from "./RecoverAccount.vue?vue&type=template&id=29bb20da"
import script from "./RecoverAccount.vue?vue&type=script&lang=js"
export * from "./RecoverAccount.vue?vue&type=script&lang=js"
script.render = render

export default script